import { Accordion as MantineAccordion, AccordionProps as MantineAccordionProps } from "@mantine/core";
import styles from "./styles.module.css";

type AccordionComponent = typeof MantineAccordion & {
  Item: typeof MantineAccordion.Item;
  Control: typeof MantineAccordion.Control;
  Panel: typeof MantineAccordion.Panel;
};

function Accordion({ children, ...rest }: MantineAccordionProps) {
  return (
    <MantineAccordion
      classNames={{
        item: styles.item,
        control: styles.control,
        content: styles.content,
      }}
      {...rest}
    >
      {children}
    </MantineAccordion>
  );
}

const TypedAccordion = Accordion as unknown as AccordionComponent;
TypedAccordion.Item = MantineAccordion.Item;
TypedAccordion.Control = MantineAccordion.Control;
TypedAccordion.Panel = MantineAccordion.Panel;

export default TypedAccordion;
